const SWATCH_TOGGLE = "color-swatch-toggle";
export {
  SWATCH_TOGGLE
};
//# sourceMappingURL=data-hooks.js.map
